import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { CaptainDAO } from '../../../../../../core/services/dao/captainDAO';
import { UserDAO } from '../../../../../../core/services/dao/userDAO';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';

@Component({
  selector: 'app-edit-availability',
  templateUrl: './edit-availability.component.html',
  styleUrls: ['./edit-availability.component.scss'],
})
export class EditAvailabilityComponent implements OnInit, OnDestroy {
  model: Captain;
  waterBodies: WaterBody[];

  constructor(
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private router: Router,
  ) {}

  ngOnInit() {
    const user = this.userDAO.getCurrentUser();
    this.model = user.captain;
    this.waterBodies = this.model.waterBodies;
  }

  ngOnDestroy(): void {}

  save(waterBodies: any) {
    let waterBodyIds = [];
    waterBodies.forEach((waterBody) => {
      waterBodyIds.push(waterBody.id);
    });
    this.captainDAO
      .updateUserCaptainWaterBodies(waterBodyIds)
      .subscribe((result) => {
        this.router.navigate(['manage']);
      });
  }
}
